import { render, staticRenderFns } from "./group-loan.vue?vue&type=template&id=03a4b164"
import script from "./group-loan.vue?vue&type=script&lang=js"
export * from "./group-loan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports